var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"xs":"12","sm":"12","md":"12","lg":"12"}},[_c('v-card',{attrs:{"outlined":""}},[_c('BookingsTable',{attrs:{"show-open":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }